import styled, { css } from 'styled-components';
import {
  SimpleGridWrapperProps,
} from '../types/SectionFeatureRow.types';

export const imageContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`;

export const imageBlock = css`
  display: block;
  width: 65px;
  height: 65px;
`;

export const assessmentPage = css`
  display: block;
  width: 100%;
  height: 100%;
  max-width: 849px;
  margin-top: -6em;
  @media (max-width: 600px) {
    margin-top: -4em;
    padding: 6%;
  }
`;

export const SimpleGridWrapper = styled.div<SimpleGridWrapperProps>`
  margin: 0 auto 20px;
  min-width: 300px;
  max-width: ${({ size }) =>
    size === 'small' ? '400px' : size === 'medium' ? '780px' : '1300px'};

  &:last-child {
    margin: 0 auto;
  }
`;

export const ButtonWrapper = styled.div`
  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    margin-right: 12px;
    margin-left: 12px;

    @media only screen and (max-width: 767px) {
      margin: 8px 33px;
      width: 100%;
    }
    [class*='button'] {
      @media only screen and (max-width: 767px) {
        width: 100%;
      }
    }
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 767px) {
    margin-top: 12px;
  }
`;

export const FeatureCardWrapper = styled.div`
  @media only screen and (max-width: 1024px) {
    [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
      width: auto;
    }
  }

  [class*='SimpleGridstyle__SimpleGrid-sc'] {
    display: flex;

    @media only screen and (max-width: 1024px) {
      flex-direction: column;
    }
  }

  @media only screen and (max-width: 1024px) {
    [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
      width: auto;
    }
  }
`;

export const whiteCSS = css`
  background-color: var(--white);
`;

export const galleryCSS = css`
  background-color: var(--gallery);
`;

export const CardsWrapper = styled.div`
  margin-bottom: 50px;
`;

export const FilterWrapper = styled.div`
  margin-bottom: 50px;
`;